import type { FC } from 'react';
import { lazy } from 'react';
import { useMemoOne } from 'use-memo-one';
import type { MmsParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useMm } from 'src/apis/iip-service/use-mm';
import { useMms } from 'src/apis/iip-service/use-mms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useMmPageParams } from 'src/pages/market-messages/maintenance-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const UpdateMaintenanceMessage: FC<Props> = ({ iipService }) => {
  const params = useMmPageParams();

  const transformedParams = useMemoOne<MmsParams>(() => {
    const { start, tsoOperatorId, ...rest } = params.value;
    return {
      offset: start,
      limit: 0,
      tsoOperatorId: tsoOperatorId.map((item) => item.value),
      ...rest,
    };
  }, [params.value]);

  const mmsRequest = useMms({ iipService, params: transformedParams });
  const mmRequest = useMm({ mmsRequest });
  if (!mmRequest.response) return <PageSpinner />;

  return <Page mmRequest={mmRequest} />;
};
